module.exports = __webpack_public_path__ + "img/Lorinthe-Icon-grey.733bee5c.svg";